import { Box, Typography } from '@wishket/design-system';
import Link from 'next/link';

import { PATH } from '@/shared/constants';

export const SubscribedSuccessTooltip = () => {
  return (
    <Box className="absolute right-0 top-[53px] w-[202px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        className="absolute -top-1 right-[29px]"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0L10 5L1.69887e-07 5L5 0Z"
          fill="white"
        />
      </svg>
      <Box className="flex w-full flex-col rounded-xl bg-w-white px-4 py-3 shadow-graymedium">
        <Typography variant="body2" className="text-w-gray-900">
          알림이 설정되었어요.
        </Typography>
        <Typography variant="body2" className="text-w-gray-900">
          <Link
            href={`${PATH.NOTIFICATION_SETTINGS}/?tab=subscription`}
            className="inline font-medium text-primary hover:underline"
          >
            [알림 설정]
          </Link>
          에서 작가별 알림을 관리해 보세요.
        </Typography>
      </Box>
    </Box>
  );
};
